import type { CountryCode } from 'libphonenumber-js'

const isProduction = process.env.NODE_ENV === 'production'

export default {
  locale: 'NO' as CountryCode,
  // enable_tracking: isProduction,
  enable_tracking: true,
  base_url: isProduction ? 'https://turbokylling.no' : 'http://localhost:3000',
  img_endpoint: 'https://img.animanorge.no',
  action_email_domain: 'action.animanorge.no',
  defaultConsent: true,
  default_to_organisations: true,
  index: true,

  site_id: 'turbokylling',
  site_name: 'Turbokylling',
  site_slogan: 'Fri for turbokylling 2026!',
  site_description: 'Signer for et Norge fritt for turbokylling i 2026.',
  site_animal: 'kylling',
  site_animal_plural: 'kyllingene',
  ngo: {
    name: 'Anima - Stopp dyremishandling',
    org_number: '918 598 510',
    address: 'Postboks 1073 Sentrum, 0104 Oslo',
    bank_account: '1503.88.62291',
    website: 'https://stoppdyremishandling.no',
    email: 'post@animanorge.no',
    phone: '92987765',
  },
  spokesperson: {
    name: 'Niklas Fjeldberg',
    title: 'Administrerende direktør i Anima',
    image_name: 'person-niklas-fjeldberg.webp',
  },
  contact_person: {
    title: 'Medlemsservice',
    name: 'Matilde Røed',
    email: 'matilde.road@animanorge.no',
    phone: '92 98 77 65',
    image_file_name: 'person-matilde-roed.webp',
  },
  site_image: {
    path: '/og/no.jpg',
    width: 1200,
    height: 630,
    mime: 'image/jpeg',
    alt: 'turbokylling',
  },
  logo: {
    width: 300,
    height: 56,
    light: '/img/logo/anima-logo_normal-white.svg',
    dark: '/img/logo/anima-logo_normal.svg',
    white: '/img/logo/anima-logo_white.svg',
    black: '/img/logo/anima-logo_black.svg',
  },
  icon: {
    width: 100,
    height: 100,
    light: '/img/logo/anima-logo-art_normal.svg',
    dark: '/img/logo/anima-logo-art_normal.svg',
  },
  social_media: {
    // Only usernames, so it works with deeplinks
    facebook: 'animanorge',
    instagram: 'animanorge',
    snapchat: 'animanorge',
    linkedin: 'animanorge',
    tiktok: undefined,
    youtube: undefined,
    bluesky: 'animanorge.bsky.social',
    xPost: 'Norge fri for turbokylling i 2026! Jeg støtter oppropet, gjør du? #FriForTurbokylling2026 https://turbokylling.no',
  },
  donate: {
    currency: 'NOK',
    currency_label: 'kr',
    amount_min: 50,
    cost_per_impact: 20,
    countdown_date: '2024-09-30',
    options: {
      recurring: [120, 205, 295, 375, 455, 545],
      one_time: [305, 510, 865, 1055, 1425, 1840],
      // recurring: [120, 205, 340, 575, 975, 1355],
      // oneTime: [205, 310, 565, 875, 1075, 1575],
    },
    options_lower: {
      recurring: undefined,
      one_time: undefined,
    },
    options_higher: {
      recurring: [165, 280, 520, 882, 1496, 2538],
      one_time: [305, 510, 865, 1465, 2490, 4225],
    },
    testimonies: [
      {
        name: 'June',
        text: 'Anima gir alle dyr en stemme, og belyser saker der forsvarsløse dyr uten nødvendige rettigheter blir skadelidende. Vi trenger organisasjoner som Anima. Anima tar tak for dyrs rettigheter, og tør å offentliggjøre sannheten bak dyrefiendtlige industrier og aktører. De stiller viktige og kritiske spørsmål, de belyser utfordringer og konsekvenser. Anima utgjør og bidrar til avgjørende forskjeller og nødvendige holdningsendringer for dyr, som ikke er i stand til å forsvare seg selv.',
        image_file_name: 'person-june.webp',
      },
      {
        name: 'Odd Bjarne',
        text: 'Jeg heier på Anima fordi dem jobber for dyrenes velferd og rettigheter, og mot de grusomhetene som dyrene stadig blir utsatt for. Jeg opplever at vi i Norge lever på en livsløgn om at dyrene hos oss har det så bra. Det viser seg gang på gang at dette ikke stemmer, og denne kunnskapen og virkeligheten må ut til folket. Anima er en stemme for de stemmeløse dyrene. Jeg støtter dem!',
        image_file_name: 'person-odd-bjarne.webp',
      },
      {
        name: 'Kamilla',
        text: 'Jeg gir fast til Anima fordi de snakker dyrenes sak. Dyrevelferd har altfor lite fokus i politikken og samfunnet, og på noen områder blir den også dårligere. Da blir det viktigere og viktigere at vi engasjerer oss.',
        image_file_name: 'person-kamilla.webp',
      },
    ],
    faq: [
      {
        question: 'Hvis jeg ønsker å avbryte den månedlige støtten min i fremtiden, hvordan kan jeg gjøre det?',
        answer: 'Støtte kan kanselleres når som helst, bare send oss en e-post så fikser vi resten.',
      },
      {
        question: 'Jeg ønsker å støtte, men bare én gang, hva skal jeg gjøre?',
        answer: 'Du kan alltid støtte med en engangsdonasjon. Månedlig støtte gir imidlertid mulighet for kontinuitet og langsiktig planlegging av kampen for dyr. Din månedlige støtte lar deg også leve etter verdiene dine hver dag. Støttebeløpet velger du selv, så det er bedre å velge en mindre månedlig støtte enn en større engangsstøtte. På denne måten vil du alltid hjelpe dyrene!',
      },
      {
        question: 'Jeg har ikke penger, hvordan kan jeg bidra?',
        answer: 'Hvis du vil bidra, del denne kampanjen med vennene dine. Du kan også be om donasjon til Anima i julegave - la de som vil gi deg en gave bli en dyreforkjemper!',
      },
    ],
  },
  tag_manager: {
    enable: true,
    id: 'GTM-TCKLW7FJ',
  },
  google: {
    enable: true,
    id: 'G-36ZEE9P8DW',
  },
  meta: {
    enable: true,
    id: '734681831807203',
    app_id: '1249106892156591',
  },
  snapchat: {
    enable: true,
    id: 'ea852092-f7df-4489-b315-21c9230aadfe',
  },
  tiktok: {
    enable: false,
    id: 'CB38T5BC77UBOJFJB420',
  },
}
